const appove_route = [
  {
    path: 'appovelist',
    name: "appovelist",
    redirect: "/appove/appovelist",
    component: resolve => {
      require(["@/views/manage/appove/AppoveIndex.vue"], resolve);
    },
    meta: {
      title: '配额审批',
      navtype: 2,
      id:[10046],
      active: '/appove/appovelist'
    },
    children: [
      {
        path: '/appove/appovelist',
        name: "appovelist",
        component: resolve => {
          require(["@/views/manage/appove/AppoveList.vue"], resolve);
        },
        meta: {
          navtype: 2,
          id:[10046],
          active: '/appove/appovelist'
        }
      },
      {
        path: '/appove/appovedetail',
        name: "appovedetail",
        component: resolve => {
          require(["@/views/manage/appove/AppoveDetail.vue"], resolve);
        },
        meta: {
          title: '配额详情',
          navtype: 2,
          id:[10046],
          active: '/appove/appovelist'
        }
      },
    ]
  },
  // {
  //   path: 'appovelist',
  //   name: "appovelist",
  //   component: resolve => {
  //     require(["@/views/manage/appove/AppoveList.vue"], resolve);
  //   },
  //   meta: {
  //     title: '配额审批',
  //     navtype: 2,
  //     id:[10046],
  //     active: '/appove/appovelist'
  //   }
  // },
  // {
  //   path: 'appovedetail',
  //   name: "appovedetail",
  //   component: resolve => {
  //     require(["@/views/manage/appove/AppoveDetail.vue"], resolve);
  //   },
  //   meta: {
  //     title: '配额详情',
  //     navtype: 2,
  //     id:[10047],
  //     active: '/appove/appovelist'
  //   }
  // },
];
export default appove_route